<template>
    <d-card v-if="userInfo.created_at" class="card-small mb-4">
        <!-- Card Header -->
        <d-card-header class="border-bottom">
            <h6 class="m-0">Account Details</h6>
        </d-card-header>
        <d-list-group flush>
            <d-list-group-item class="p-3">
                <d-row>
                    <d-col>
                        <d-form id="userForm" @submit.prevent="update">
                            <d-form-row>
                                <d-col md="6" class="form-group">
                                    <label for="firstName">First Name</label>
                                    <input minlength="3" class="form-control" required type="text" id="firstName" placeholder="First Name" v-model="userInfo.first_name" />
                                </d-col>
                                <d-col md="6" class="form-group">
                                    <label for="lastName">Last Name</label>
                                    <input minlength="3" class="form-control" required type="text" id="lastName" placeholder="Last Name" v-model="userInfo.last_name" />
                                </d-col>
                            </d-form-row>
                            <d-form-row>
                                <d-col md="6" class="form-group">
                                    <label for="phoneNumber">Phone Number</label>
                                    <d-input-group seamless>
                                        <d-input-group-text slot="prepend">
                                            <i class="material-icons">&#xE0CD;</i>
                                        </d-input-group-text>
                                        <input minlength="3" class="form-control" id="phoneNumber" type="number" v-model="userInfo.phone" />
                                    </d-input-group>
                                </d-col>
                                <d-col md="6" class="form-group">
                                    <label for="emailAddress">Email</label>
                                    <d-input-group seamless>
                                        <d-input-group-text slot="prepend">
                                            <i class="material-icons">&#xE0BE;</i>
                                        </d-input-group-text>
                                        <input class="form-control" required id="emailAddress" v-model="userInfo.email" type="email" />
                                    </d-input-group>
                                </d-col>
                            </d-form-row>

                            <hr />
                            <d-form-row>
                                <d-col md="6" class="form-group">
                                    <label for="addressLine1">Address line 1</label>
                                    <input minlength="3" class="form-control" type="text" id="addressLine1" v-model="userInfo.address_1" />
                                </d-col>
                                <d-col md="6" class="form-group">
                                    <label for="addressLine2">Address line 2</label>
                                    <input minlength="3" class="form-control" type="text" id="addressLine2" placeholder="enter address (2)" v-model="userInfo.address_2" />
                                </d-col>
                                <d-col md="6" class="form-group">
                                    <label for="city">City</label>
                                    <d-input-group seamless>
                                        <d-input-group-text slot="prepend">
                                            <i class="material-icons">&#xE0C8;</i>
                                        </d-input-group-text>
                                        <input minlength="3" class="form-control" id="city" v-model="userInfo.city" />
                                    </d-input-group>
                                </d-col>
                                <d-col md="6" class="form-group">
                                    <label for="state">State, Province or Region</label>
                                    <input minlength="3" class="form-control" type="text" id="state" v-model="userInfo.state" />
                                </d-col>
                                <d-col md="6" class="form-group">
                                    <label for="zipCode">Zip code</label>
                                    <input minlength="3" class="form-control" type="text" id="zipCode" v-model="userInfo.postcode" />
                                </d-col>
                                <d-col md="6" class="form-group">
                                    <label for="country">Country</label>
                                    <d-form-select v-model="userInfo.country.code">
                                        <option v-for="item in Countries" :value="item.code">{{ item.name }}</option>
                                    </d-form-select>
                                </d-col>
                            </d-form-row>
                            <hr />
                            <d-form-row>
                                <d-col md="6" class="form-group">
                                    <label for="companyName">Name of company</label>
                                    <input minlength="3" id="companyName" class="form-control" placeholder="Company name" v-model="userInfo.company" />
                                </d-col>
                                <d-col md="6" class="form-group">
                                    <label for="vat">VAT number</label>
                                    <input minlength="3" id="vat" class="form-control" placeholder="VAT number" v-model="userInfo.vat" />
                                </d-col>
                                <p v-if="errors.length">
                                    <b class="text-danger" v-for="error in errors">{{ error }}</b>
                                </p>
                            </d-form-row>
                        </d-form>
                    </d-col>
                </d-row>
            </d-list-group-item>
        </d-list-group>
        <d-card-footer class="border-top d-flex justify-content-end">
            <input form="userForm" value="Update Account" type="submit" class="btn btn-accent">
        </d-card-footer>
    </d-card>
</template>

<script>
    import { UserService, CountryResource } from '@/main';
    import notification from '@/mixins/notification';

    export default {
        mixins: [notification],

        data() {
            return {
                Countries: [],
                errors: []
            }
        },
        methods: {
            async update() {
                try {
                    await UserService.update(this.userInfo)
                    this.showNotification('success', 'Alert', 'User succesfully updated!')
                    this.$router.go()
                } catch(e) {
                    console.log(e)
                    this.errors = [];
                    this.errors.push("Update not successful!");
                }
            },

            async getCountries() {
                try {
                    const countries = await CountryResource.get()
                    this.Countries = countries.data.countries
                } catch(e) {
                    return false
                }
            },
        },

        created () {
            this.getCountries()
            this.userInfo.address_1 = this.userInfo.address_1 + ' ' + (this.billingInfo ? this.billingInfo.houseNumber : '')
        },

        computed: {
            userInfo () {
                return this.$store.getters.userInfo
            },

            billingInfo () {
                if (this.$store.getters.getBillingInfo.planId) {
                    return this.$store.getters.getBillingInfo
                }
            }
        }
    }
</script>

